import { createSlice } from "@reduxjs/toolkit";

/**
 * whether we're currently re-taking a picture
 * value should be a boolean
 */
export const manualOnlySlice = createSlice({
  name: "manualOnly",
  initialState: {
    value: false,
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
    reset: (state) => {
      state.value = false;
    },
  },
});

export const { update, reset } = manualOnlySlice.actions;

export default manualOnlySlice.reducer;
